import React, { ReactElement, useEffect } from 'react';
import { InsertRightIcon } from '@milanote/roma-icons';
import useSheet from '../../../../../../mobile/structural/sheet/hooks/useSheet';
import { SheetId } from '../../../../../../mobile/structural/sheet/sheetTypes';
import MobileInsertMenuSheet from './MobileInsertMenuSheet';
import ToolbarTool from '../../../ToolbarTool';
import RomaToolbarIcon from '../../../roma/RomaToolbarIcon';
import { ImMNElement } from '../../../../../../../common/elements/elementModelTypes';
import { getElementType } from '../../../../../../../common/elements/utils/elementPropertyUtils';
import { ElementType } from '../../../../../../../common/elements/elementTypes';

type MobileInsertMenuToolProps = {
    name: string;
    editorKey?: string;
    element?: ImMNElement;
};

const MobileInsertMenuTool = ({ name, editorKey, element }: MobileInsertMenuToolProps): ReactElement | null => {
    const sheetProps = useSheet(SheetId.InsertMenuTool);
    const { isOpen, openSheet, closeSheet } = sheetProps;

    const isTaskListContext = getElementType(element) === ElementType.TASK_LIST_TYPE;

    useEffect(() => {
        if (!isOpen || editorKey) return;

        closeSheet();
    }, [isOpen, editorKey, closeSheet]);

    return (
        <>
            <ToolbarTool name={name} isOpen={isOpen} onClick={() => openSheet()}>
                <RomaToolbarIcon icon={InsertRightIcon} iconClassName="size-5" />
            </ToolbarTool>
            <MobileInsertMenuSheet sheetProps={sheetProps} isTaskListContext={isTaskListContext} />
        </>
    );
};

export default MobileInsertMenuTool;
